import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getSection, getSectionByGraphId } from "actions/sections";
import SectionTitle from 'components/Presentation/SectionTitle';
import SectionForm from 'containers/Forms/SectionForm';
import SectionProgress from 'containers/Progress/Section';
import TeacherSectionProgress from 'containers/Progress/TeacherSection';
import { isUserTeacher } from 'helpers/user';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { setPageTitle, setPageActions } from 'actions/header';
import Modal from 'containers/Modals/Modal';
import * as microsoftTeams from "@microsoft/teams-js";

var MyAssessments = /*#__PURE__*/function (_Component) {
  _inherits(MyAssessments, _Component);

  var _super = _createSuper(MyAssessments);

  function MyAssessments(props) {
    var _this;

    _classCallCheck(this, MyAssessments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageActions([{
        type: 'icon',
        onClick: _this.toggleGroupSettings,
        icon: 'cog_bw'
      }]);

      _this.props.setPageTitle(_this.props.translate('assessments-header-overview'));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.initComponent();
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (_this.props.sections.length == 0 && nextProps.sections.length > 0) {
        _this.setState({
          isLoading: true
        });

        _this.loadContext();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroupSettings", function (shouldReload) {
      _this.setState({
        groupForm: !_this.state.groupForm
      });

      if (shouldReload == true) {
        microsoftTeams.app.getContext().then(function (context) {
          _this.props.getSectionByGraphId(context.team.groupId);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "initComponent", function () {
      var _this$props = _this.props,
          group = _this$props.group,
          sections = _this$props.sections;

      if (sections != null && sections.length > 0) {
        if (group == null) {
          _this.setState({
            isLoading: true
          });

          _this.loadContext();
        }
      } else {
        microsoftTeams.app.getContext().then(function (teamsContext) {
          _this.setState({
            isLoading: false,
            teamsContext: teamsContext
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "teamsTabCloseForm", function () {
      _this.setState({
        noSectionFound: false
      }, function () {
        window.location = window.location.href;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var isTeacher = isUserTeacher(_this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", null, _this.props.group != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.groupForm,
        onClose: _this.toggleGroupSettings,
        title: _this.props.group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: _this.toggleGroupSettings,
        editView: true,
        section: _this.props.group
      })) : null, _this.props.group.students && _this.props.group.students.length > 0 && isTeacher ? /*#__PURE__*/React.createElement("div", {
        id: "section-pupils",
        className: "single-section form"
      }, /*#__PURE__*/React.createElement(TeacherSectionProgress, {
        groupId: _this.props.group.id
      })) : null, _this.state.isLoading == false && isTeacher == false && _this.state.noSectionFound == false ? _this.renderStudentView() : null);
    });

    _this.state = {
      sectionId: null,
      noSectionFound: false,
      teamsContext: null,
      isLoading: false
    };
    return _this;
  }

  _createClass(MyAssessments, [{
    key: "loadContext",
    value: function loadContext() {
      var _this2 = this;

      microsoftTeams.app.getContext().then(function (context) {
        var group = _this2.props.group;

        var section = _this2.props.sections.find(function (section) {
          return section.graphId == context.team.groupId;
        });

        if (section != null) {
          _this2.setState({
            sectionId: section.id,
            noSectionFound: false,
            teamsContext: context
          });

          if (_this2.props.group != null) {
            _this2.setState({
              isLoading: false
            });
          } else {
            _this2.props.getSection(section.id).then(function () {
              _this2.setState({
                isLoading: false
              });
            });
          }
        } else {
          _this2.setState({
            noSectionFound: true,
            teamsContext: context,
            isLoading: false
          });
        }
      });
    }
  }, {
    key: "renderStudentView",
    value: function renderStudentView() {
      return /*#__PURE__*/React.createElement("div", {
        id: "section-assessment",
        className: "single-section form"
      }, /*#__PURE__*/React.createElement(SectionProgress, {
        groupId: this.props.group.id,
        userId: this.props.currentUser.id
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.isLoading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var isTeacher = isUserTeacher(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "container my_assessments"
      }, this.props.group != null ? this.renderContent() : null, this.state.noSectionFound == true && isTeacher ? /*#__PURE__*/React.createElement(SectionForm, {
        editView: false,
        teamsContext: this.state.teamsContext,
        teamsTabCloseForm: this.teamsTabCloseForm,
        tab: "assessments",
        onboarding: true
      }) : null);
    }
  }]);

  return MyAssessments;
}(Component);

function mapStateToProps(state) {
  return {
    sections: state.sections.educationGroups,
    group: state.sections.activeSection,
    graphSection: state.sections.graphSection,
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getSection: getSection,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getSectionByGraphId: getSectionByGraphId
})(MyAssessments);